import React, {
  forwardRef,
  useImperativeHandle,
  useEffect,
  useState,
} from "react";
import Spinner from "../../components/Spinner/Spinner";
import { connect } from "react-redux";
import { constants } from "../../firebase/firestoreNameSpaces";
import * as actions from "../../store/actions/index";
import PaymentType from "./Utils/PaymentType";

const Payment = forwardRef((props, ref) => {
  const [md_available, setMd] = useState({
    [constants.PAYMENT_CASH]: false,
    [constants.PAYMENT_ONLINE]: false,
  });
  const [loading, setLoading] = useState(false);
  useImperativeHandle(ref, () => ({
    proceed() {
      //validation code
      return new Promise((resolve, reject) => {
        if (props.order.payment_mode) {
          resolve(true);
        } else {
          alert("Please Select a Payment Mode");
          resolve(false);
        }
      });
    },
  }));

  useEffect(async () => {
    try {
      let pincode = props.order.address.pincode;
      let payment_mode = props.order.payment_mode;
      setLoading(true);
      props.setVisibility(false);
      let md_available = await props.checkServiceAvailability(
        pincode,
        payment_mode
      );

      setMd(md_available);
      setLoading(false);
      props.setVisibility(true);
    } catch (error) {}
  }, []);

  return (
    <div className="container">
      {loading ? (
        <Spinner />
      ) : (
        <>
          {!md_available[constants.PAYMENT_ONLINE] &&
          !md_available[constants.PAYMENT_CASH] ? (
            <div className="m-4">
              <h4 className="mt-2">Not Deliverable At this Pincode.</h4>
            </div>
          ) : (
            <h4 className="mt-2">Select a payment method</h4>
          )}

          <PaymentType
            COD={md_available[constants.PAYMENT_CASH]}
            Prepaid={md_available[constants.PAYMENT_ONLINE]}
          />
        </>
      )}
    </div>
  );
});
const mapStateToProps = (state) => {
  return {
    order: state.cart.order,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    checkServiceAvailability: (pincode, payment_mode) =>
      dispatch(actions.checkServiceAvailability(pincode, payment_mode)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(Payment);
